import { render, staticRenderFns } from "./reviews.vue?vue&type=template&id=30eddefd&"
import script from "./reviews.vue?vue&type=script&lang=ts&"
export * from "./reviews.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports